import axios from 'axios'

import store from '@/store'
import { ERRORS } from '@/utils/errors'

const defineError = ({ error }) => {
  return error
    ? {
        code: error.code || null,
        message: error.message || ERRORS[error.code] || 'Невідома помилка'
      }
    : null
}

const request = {
  onBeforeSent: config => {
    const accessToken = store.state.auth.accessToken
    const isFormData = config.data instanceof FormData

    const headers = {
      'client-origin': window.location.origin,
      ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
      ...(isFormData && { 'Content-Type': 'multipart/form-data' })
      // 'Access-Control-Allow-Origin': '*'
    }

    config.headers = { ...config.headers, ...headers }

    return config
  },
  onError: Promise.reject
}

const response = {
  onSuccess: response => {
    const data = response?.data || {}
    const isSuccess = data.isSuccess === false ? false : true
    const error = defineError(data)

    delete data.isSuccess
    delete data.error

    const content = Object.keys(data).length ? data : null

    return { isSuccess, error, content }
  },

  onError: error => {
    const { response } = error

    if (response?.status === 401) {
      store.dispatch('auth/LOGOUT', {}, { root: true })
      return { isSuccess: false }
    }

    return Promise.reject(new Error(error))
  }
}

axios.defaults.baseURL = import.meta.env.VITE_VUE_APP_API_URL
axios.defaults.withCredentials = true

axios.interceptors.request.use(request.onBeforeSent, request.onError)
axios.interceptors.response.use(response.onSuccess, response.onError)
